import types from "cms/enums/contentsTypes.enum";
export var slider = {
    label: "Plage de valeurs",
    type: types.SLIDER,
    value: "100",
    min: "0",
    max: "100",
    step: "10"
};
